import {ICON_TYPES} from '../constants';

export const LifeStyle = (): JSX.Element => {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13327_20909)'>
        <path
          d='M18.7302 6.3245C18.4861 5.99206 18.1673 5.72162 17.7995 5.53498C17.4317 5.34834 17.0252 5.25073 16.6127 5.25H4.38723C3.97479 5.25073 3.56828 5.34834 3.20047 5.53498C2.83267 5.72162 2.51386 5.99206 2.26973 6.3245L0.478608 8.76837C0.101718 9.28098 -0.0756007 9.91329 -0.0202049 10.5471C0.0351909 11.181 0.31951 11.7729 0.779608 12.2124L10.5 20.9396L20.2527 12.1826C20.7013 11.7417 20.9755 11.1536 21.0248 10.5266C21.0742 9.89955 20.8954 9.27579 20.5214 8.77012L18.7302 6.3245ZM6.39536 11.375L8.41223 16.7125L2.46398 11.375H6.39536ZM12.7339 11.375L10.5 17.2874L8.26611 11.375H12.7339ZM8.29236 9.625L9.34236 7H11.6576L12.7076 9.625H8.29236ZM14.6046 11.375H18.5342L12.5842 16.7125L14.6046 11.375ZM17.3171 7.35788L18.9805 9.625H14.5924L13.5424 7H16.6127C16.7503 6.99995 16.8859 7.03234 17.0086 7.09452C17.1313 7.1567 17.2376 7.24692 17.3189 7.35788H17.3171ZM3.67936 7.35788C3.76082 7.24668 3.8674 7.15631 3.99041 7.09412C4.11343 7.03193 4.24939 6.99968 4.38723 7H7.45761L6.40761 9.625H2.01948L3.67936 7.35788Z'
          fill='#43494F'
        />
        <path d='M11.375 0H9.625V3.5H11.375V0Z' fill='#43494F' />
        <path
          d='M15.8873 0.49885L14.1375 3.24902L15.6145 4.18877L17.3643 1.4386L15.8873 0.49885Z'
          fill='#43494F'
        />
        <path
          d='M5.1131 0.506042L3.63684 1.4458L5.38667 4.1946L6.86294 3.25484L5.1131 0.506042Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

LifeStyle.iconType = ICON_TYPES.LIFE_STYLE_ICON;
